import 'antd/lib/tree-select/style';
//# sourceMappingURL=index.js.map